import { useState } from "react";
import BASE_URL from "../Utilities/BASE_URL";
import { useTranslation } from "react-i18next";
const useFetch = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(null);

  const { i18n } = useTranslation();

  const fetchData = async (url, token) => {
    setIsLoading(true);
    try {
      const headers = {
        "Content-Type": "application/json",
      };

      // Add Authorization header if token is provided
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }

      const response = await fetch(`${BASE_URL}/${i18n?.language}/${url}`, {
        method: "GET",
        headers,
        credentials: "include",
        mode: "cors",
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await response.json();

      setData(result);
      return result;
    } catch (error) {
      console.error("Fetch error:", error);
      setIsError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return { data, isLoading, isError, fetchData };
};

export default useFetch;
